<template>
  <div class="templte">
    <div class="addBox">
      <el-button
        type="primary"
        size="mini"
        class="add"
        @click="AddGrowthMessage"
      >
        添加寄语模板<i class="el-icon-circle-plus" style="font-size: 14px"></i>
      </el-button>
    </div>
    <div class="GrowthMessageTextList">
      <div
        class="flexs_dis"
        v-for="(item, index) in GrowthMessageTextLists"
        :key="index"
        @click="UseGrowthMessage(item.GrowthMessageText)"
      >
        <div class="li">
          {{ item.GrowthMessageText }}
        </div>
        <div class="icons" v-if="item.type == false">
          <div
            class="icon"
            style="cursor: pointer"
            @click.stop="DeleteGrowthMessage(item.Id, item.type)"
          >
            <i class="el-icon-delete" style="font-size: 20px"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="paginationBox">
      <el-pagination
        :hide-on-single-page="true"
        @current-change="currentcChange"
        small
        :page-size="5"
        layout="prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  FrontGetMessageTemplateList,
  FrontDeleteMessageTemplate,
  FrontAddMessageTemplate,
} from "@/api/api";
export default {
  props: {
    addition: {},
    // 寄语类型 6个纬度 对应的 纬度名称 是这里 0是通用 666是学期寄语 999是过程寄语
    MessageType: {
      type: String,
      default: "999",
    },
    // // 学期寄语140字 主题评价300 其余500字
    maxTextLength: {
      type: Number,
      default: 500,
    },
  },
  data() {
    return {
      GrowthMessageTextLists: [],
      PageSize: 5,
      PageIndex: 1,
      total: 0,
    };
  },
  created() {
    this.GrowthMessageTextLists = [];
    this.PageIndex = 1;
    this.PageSize = 5;
    this.getRecommend();
  },
  watch: {
    MessageType() {
      this.getRecommend();
    },
  },
  methods: {
    currentcChange(e) {

      this.PageIndex = e;
      this.getRecommend();
    },
    async getRecommend() {
      let res = await FrontGetMessageTemplateList({
        PageSize: this.PageSize,
        PageIndex: this.PageIndex,
        MessageType: this.MessageType,
      });
      if (res.data.success) {
        this.GrowthMessageTextLists = res.data.response.data;
        this.total = res.data.response.dataCount;

      } else {
        this.GrowthMessageTextLists = [];
      }
    },
    UseGrowthMessage(text) {
      this.$emit("select", {
        content: text,
        addition: this.addition,
      });
    },
    DeleteGrowthMessage(Id, type) {
      if (type == false) {
        this.$confirm("是否确认删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            FrontDeleteMessageTemplate({
              ids: [Id],
            }).then((res) => {
              if (res.data.success) {
                this.getRecommend();
                this.$message({
                  type: "success",
                  message: "已删除",
                });
              }
            });
          })
          .catch(() => {});
      } else {
        this.$message({
          type: "warning",
          message: "此条不可删除",
        });
      }
    },
    AddGrowthMessage() {
      this.$prompt("添加寄语模板", {
        confirmButtonText: "保存添加",
        cancelButtonText: "取消添加",
        inputType: "textarea",
        inputErrorMessage: `请保持在${this.maxTextLength}字以内`,
      })
        .then(({ value }) => {
          if (value != null) {
            if (value.length <= this.maxTextLength) {
              FrontAddMessageTemplate({
                Content: value,
                MessageType: this.MessageType,
              }).then((res) => {
                if (res.data.success) {
                  this.getRecommend();
                  this.$message({
                    type: "success",
                    message: "添加成功",
                  });
                }
              });
            } else {
              this.$message({
                type: "error",
                message: `请保持在${this.maxTextLength}字以内`,
              });
            }
          } else {
            this.$message({
              type: "error",
              message: "请输入寄语模板内容",
            });
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style>
.addBox {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
}
.add {
  display: flex;
  align-items: center;
}
.flexs_dis {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  border-bottom: 1px #cccccc dashed;
  padding: 5px 0;
}
.GrowthMessageTextList .flexs_dis:nth-last-child(1) {
  border-bottom: none;
}
.liIndex {
  width: 10px;
}
.paginationBox {
  display: flex;
  align-items: center;
  justify-content: center;
}
.li {
  flex: 1;
}
</style>